import { MthColor } from '@mth/enums'

const mthButtonCommonStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
}

const disabledClass = {
  '&:disabled': {
    opacity: 0.5,
  },
}

export const mthButtonSizeClasses = {
  xs: {
    ...mthButtonCommonStyles,
    height: '29px',
    fontSize: '12px',
    fontWeight: '700',
    padding: '6px 16px',
  },
  small: {
    ...mthButtonCommonStyles,
    height: '36px',
    fontSize: '12px',
    fontWeight: '700',
    padding: '11px 16px',
  },
  medium: {
    ...mthButtonCommonStyles,
    height: '48px',
    fontSize: '12px',
    fontWeight: '700',
    padding: '11px 16px',
  },
}

export const mthButtonColorClasses = {
  primary: {
    background: MthColor.BUTTON_LINEAR_GRADIENT,
    color: MthColor.WHITE,
    '&:hover': {
      background: MthColor.PRIMARY_MEDIUM_MOUSEOVER,
      color: MthColor.WHITE,
    },
    ...disabledClass,
  },
  dark: {
    background: MthColor.BUTTON_LINEAR_GRADIENT_DARK,
    color: MthColor.WHITE,
    '&:hover': {
      background: MthColor.SYSTEM_01,
      color: MthColor.WHITE,
    },
    ...disabledClass,
  },
  gray: {
    background: MthColor.LIGHTGRAY,
    color: MthColor.SYSTEM_01,
    '&:hover': {
      background: MthColor.LIGHTGRAY,
      color: MthColor.SYSTEM_01,
    },
  },
  darkGray: {
    background: MthColor.SYSTEM_08,
    color: MthColor.SYSTEM_01,
    '&:hover': {
      background: MthColor.SYSTEM_08,
      color: MthColor.SYSTEM_01,
    },
  },
  orangeReverse: {
    background: MthColor.MTHORANGE,
    color: MthColor.WHITE,
    '&:hover': {
      background: MthColor.ORANGE_GRADIENT,
      color: MthColor.WHITE,
    },
  },
  orange: {
    background: MthColor.ORANGE_GRADIENT,
    color: MthColor.WHITE,
    '&:hover': {
      background: MthColor.MTHORANGE,
      color: MthColor.WHITE,
    },
    ...disabledClass,
  },
  mthGreen: {
    background: MthColor.MTHGREEN_GRADIENT,
    color: MthColor.WHITE,
    '&:hover': {
      background: MthColor.MTHGREEN,
      color: MthColor.WHITE,
    },
  },
  red: {
    background: MthColor.RED_GRADIENT,
    color: MthColor.WHITE,
    '&:hover': {
      background: MthColor.RED,
      color: MthColor.WHITE,
    },
    ...disabledClass,
  },
  redReverse: {
    background: MthColor.RED,
    color: MthColor.WHITE,
    '&:hover': {
      background: MthColor.RED_GRADIENT,
      color: MthColor.WHITE,
    },
  },
  green: {
    background: MthColor.GREEN_GRADIENT,
    color: MthColor.WHITE,
    '&:hover': {
      background: MthColor.GREEN,
      color: MthColor.WHITE,
    },
    ...disabledClass,
  },
  black: {
    background: MthColor.SYSTEM_01,
    color: MthColor.WHITE,
    '&:hover': {
      background: MthColor.SYSTEM_01,
      color: MthColor.WHITE,
    },
  },
  yellow: {
    background: MthColor.YELLOW_GRADIENT,
    color: MthColor.WHITE,
    '&:hover': {
      background: MthColor.YELLOW,
      color: MthColor.WHITE,
    },
    ...disabledClass,
  },
}

export const mthButtonClasses = {
  // Primary buttons
  primary: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.primary,
    borderRadius: '8px',
    minWidth: '140px',
  },
  roundPrimary: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.primary,
    borderRadius: '40px',
  },
  smallPrimary: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.primary,
    borderRadius: '8px',
  },
  xsPrimary: {
    ...mthButtonSizeClasses.xs,
    ...mthButtonColorClasses.primary,
    borderRadius: '8px',
    minWidth: '92px',
  },
  roundSmallPrimary: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.primary,
    borderRadius: '40px',
    minWidth: '100px',
  },
  roundXsPrimary: {
    ...mthButtonSizeClasses.xs,
    ...mthButtonColorClasses.primary,
    borderRadius: '40px',
    minWidth: '92px',
  },

  // Dark gradient buttons
  dark: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.dark,
    borderRadius: '8px',
    minWidth: '140px',
  },
  roundDark: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.dark,
    borderRadius: '40px',
  },
  smallDark: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.dark,
    borderRadius: '8px',
  },
  roundSmallDark: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.dark,
    borderRadius: '40px',
  },
  roundXsDark: {
    ...mthButtonSizeClasses.xs,
    ...mthButtonColorClasses.dark,
    borderRadius: '40px',
    minWidth: '92px',
  },

  // black buttons
  black: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.black,
    borderRadius: '8px',
    minWidth: '140px',
  },

  // Gray buttons
  gray: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.gray,
    borderRadius: '8px',
    minWidth: '140px',
  },
  roundGray: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.gray,
    borderRadius: '40px',
  },
  smallGray: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.gray,
  },
  roundSmallGray: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.gray,
    borderRadius: '40px',
  },
  roundXsGray: {
    ...mthButtonSizeClasses.xs,
    ...mthButtonColorClasses.gray,
    borderRadius: '40px',
    minWidth: '92px',
  },

  // Dark gray buttons
  darkGray: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.darkGray,
    borderRadius: '8px',
    minWidth: '140px',
  },

  roundDarkGray: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.darkGray,
    borderRadius: '20px',
  },

  requiredErrorButton: {
    border: 1,
    borderColor: MthColor.RED,
  },

  // Orange buttons
  orangeReverse: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.orangeReverse,
    borderRadius: '8px',
    minWidth: '140px',
  },
  orange: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.orange,
    borderRadius: '8px',
    minWidth: '140px',
  },
  roundOrange: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.orange,
    borderRadius: '40px',
  },
  smallOrange: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.orange,
  },
  roundSmallOrange: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.orange,
    borderRadius: '40px',
  },

  // MthGreen buttons
  mthGreen: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.mthGreen,
    borderRadius: '8px',
    minWidth: '120px',
  },
  roundMthGreen: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.mthGreen,
    borderRadius: '40px',
  },
  smallMthGreen: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.mthGreen,
  },
  roundSmallMthGreen: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.mthGreen,
    borderRadius: '40px',
  },

  // Red buttons
  red: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.red,
    borderRadius: '8px',
    minWidth: '140px',
  },
  redReverse: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.redReverse,
    borderRadius: '8px',
  },
  smallRed: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.red,
    borderRadius: '8px',
  },
  xsRed: {
    ...mthButtonSizeClasses.xs,
    ...mthButtonColorClasses.red,
    borderRadius: '8px',
    minWidth: '92px',
  },
  roundXsRed: {
    ...mthButtonSizeClasses.xs,
    ...mthButtonColorClasses.red,
    borderRadius: '40px',
    minWidth: '92px',
  },

  // Green buttons
  green: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.green,
    borderRadius: '8px',
    minWidth: '140px',
  },
  roundXsGreen: {
    ...mthButtonSizeClasses.xs,
    ...mthButtonColorClasses.green,
    borderRadius: '40px',
    minWidth: '92px',
  },

  // Black buttons
  roundSmallBlack: {
    ...mthButtonSizeClasses.small,
    ...mthButtonColorClasses.black,
    borderRadius: '40px',
    minWidth: '92px',
  },

  // Yellow buttons
  yellow: {
    ...mthButtonSizeClasses.medium,
    ...mthButtonColorClasses.yellow,
    borderRadius: '8px',
    minWidth: '140px',
  },
  uploadFile: {
    padding: '8px 16px',
    height: 'unset',
  },
}
